import { render, staticRenderFns } from "./common-lookup.vue?vue&type=template&id=f98fefaa&scoped=true&"
import script from "./common-lookup.vue?vue&type=script&lang=js&"
export * from "./common-lookup.vue?vue&type=script&lang=js&"
import style0 from "./common-lookup.vue?vue&type=style&index=0&id=f98fefaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98fefaa",
  null
  
)

export default component.exports